import { Outlet, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { AccessibilitySwitcher, LanguageSwitcher } from "@/features/settings";
import { useGetPublicUnitInfoQuery } from "@/features/accounting/warehouse";

export default function PublicLayout() {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation("WarehousePage");
  const isPublicUnit = pathname.startsWith("/warehouse/units/");
  const barcode = isPublicUnit ? pathname.split("/warehouse/units/")[1]?.split("/")[0] || "" : "";

  const { data: unit } = useGetPublicUnitInfoQuery(barcode, { skip: !isPublicUnit || !barcode });

  const localeKey = i18n.language === "kk" ? "kk" : "ru";
  const orgName = unit?.organization_name ?? null;
  const orgAbbrev = unit?.organization_type_display?.[localeKey]?.abbreviation ?? null;
  const orgLabel = orgName ? (orgAbbrev ? `${orgAbbrev} «${orgName}»` : orgName) : null;

  return (
    <div className="surface-secondary-fill min-h-screen flex flex-col">
      <header className="w-full flex py-4 justify-between items-center px-5">
        {isPublicUnit && orgLabel ? (
          <div className="flex flex-col">
            <p className="text-display-2xs content-base-primary">{orgLabel}</p>
            {unit?.organization_bin && (
              <p className="text-body-regular-xs content-base-secondary">
                {t("publicUnit.orgBin")}: {unit.organization_bin}
              </p>
            )}
          </div>
        ) : (
          <p></p>
        )}
        <div className="flex items-center gap-3 xl:mr-0 mr-4">
          <LanguageSwitcher />
          <AccessibilitySwitcher />
        </div>
      </header>
      <main className="grow flex flex-col">
        <Outlet />
      </main>
    </div>
  );
}
